import React from "react";
import Modal from "react-bootstrap/Modal";
const CusModal = ({ show, onHide, children, className, enforceFocus = true }) => {
  return (
    <div>
      <Modal show={show} onHide={onHide} backdrop="static"
      centered
      // enforceFocus must be disabled when this modal hosts a nested dialog whose
      // react-select menu portals to document.body — otherwise Bootstrap steals focus
      // back on menu open and the dropdown closes instantly.
      enforceFocus={enforceFocus}
      className={className}>
        {children}
      </Modal>
    </div>
  );
};

export default CusModal;
